import $ from 'jquery';
// import debug from 'bows';

// const log = debug('layout:tabs');

class Tabs {
	constructor(node) {
		this.node = node;
		this.$node = $(this.node);
		this.$window = $(window);
		this.$node.addClass('--initialized');
		this.$navsDesktop = this.$node.find('.flex-layout--conference-tabs__nav a');
		this.$navsMobile = this.$node.find('.flex-layout--conference-tabs__nav--mobile');
		this.$content = this.$node.find('.flex-layout--conference-tabs__tab');
		this.$tabContent = this.$node.find('.flex-layout--conference-tabs__tab__content');
		this.activeClass = 'flex-layout--conference-tabs--active';
		this.activeClassMobile = 'flex-layout--conference-tabs--active--mobile';
		this.hashes = this.$navsDesktop.toArray().map(( nav ) => nav.hash );

		let activate = ( e ) => {
			e.preventDefault();
			this.history( e.currentTarget.hash );
			this.activate(e.currentTarget.getAttribute('data-index'));
		}

		this.$navsDesktop.each(( index, node ) => {
			node.setAttribute('data-index', index);
		}).on('click', activate);

		this.$navsMobile.each(( index, node ) => {
			node.setAttribute('data-index', index);
		}).on('click', activate);

		this.active = -1;

		if ( window.history.pushState ) {
			window.addEventListener('popstate', () => {
				if ( this.hashes.indexOf( window.location.hash ) > -1 ) {
					this.activate( this.hashes.indexOf( window.location.hash ) );
				}
			});
		}

		if ( window.location.hash ) {
			if ( this.hashes.indexOf( window.location.hash ) ) {
				this.activate( this.hashes.indexOf( window.location.hash ) );
			}
		}

		if ( this.active === -1 ) {
			this.activate(0);
		}
	}

	activate(index, focus = false) {
		if (this.active > -1) {
			this.$navsDesktop.eq(this.active).removeClass(this.activeClass);
			this.$content.eq(this.active).removeClass(this.activeClass);
		}

		this.active = index;
		this.$navsDesktop.eq(this.active).addClass(this.activeClass);
		this.$content.eq(this.active).addClass(this.activeClass);

		if (this.$window.width() < 800) {
			this.$tabContent.eq(this.active).slideToggle(400, () => {
				this.$tabContent.eq(this.active).css('display', '');
				this.$content.eq(this.active).toggleClass(this.activeClassMobile);
			});
		}

		if ( focus ) {
			window.scrollTo( 0, this.$content.eq( this.active ).offset().top - 60 );
		}

	}

	history( hash ) {
		if ( window.history.pushState ) {
			window.history.pushState( null, null, hash );
		} else {
			window.location.hash = hash;
		}
	}
}

export default Tabs;
